<section id="schedaConsegna" class="content-padding">
  <div class="sale-container">
    <div class="card sale-info">
      <h3>Delivery Info</h3>
      <p><strong>Order ID:</strong> #DEL-1023</p>
      <p><strong>Customer:</strong> John Doe</p>
      <p><strong>Address:</strong> 123 Main Street</p>
      <p class="total"><strong>Total:</strong> $249.00</p>
    </div>

    <div class="card payment-card">
      <h3>Pay with Stripe</h3>
      <div id="stripe-card-element" class="stripe-box"></div>
      <button class="btn-primary" (click)="payWithStripe()">
        Pay with Card
      </button>

      <h3 class="mt-4">Or Pay with PayPal</h3>
      <div id="paypal-button-container"></div>
    </div>
  </div>
</section>

<!-- 
<section id="schedaConsegna" class="content-padding">
  <div class="sale-container">
    <div class="card sale-info">
      <h3>Delivery Info</h3>
      <p><strong>Order ID:</strong> #DEL-1023</p>
      <p><strong>Customer:</strong> John Doe</p>
      <p><strong>Address:</strong> 123 Main Street</p>
      <p class="total"><strong>Total:</strong> $249.00</p>
    </div>

    <div class="card payment-card">
      <h3>Checkout</h3>
      <button class="btn-primary" (click)="payWithCheckout()">
        Pay with Stripe Checkout
      </button>
      <p class="mt-2">
        Supports <strong>PayPal, Google Pay, Apple Pay, Klarna</strong> and more
        depending on your Stripe account settings.
      </p>
    </div>
  </div>
</section> 
-->
